<template>
  <div class="main__login">
    <div class="main__login__shade"></div>
    <el-card
      :body-style="{ padding: '80px 76px' }"
      dis-hover
      style="width: 700px; z-index: 1"
    >
      <div class="main__login__title">Online check-in</div>
      <div class="main__login__subtitle">Search for your booking below</div>
      <div v-if="isSiteOnMaintenance()" class="main__maintenance">
        <h2>
          We are upgrading our system to serve you better and will be back
          shortly. Please check back later, or contact Aqua Expeditions for any
          enquiries.
        </h2>
      </div>
      <el-form
        v-else
        ref="formValidate"
        :model="formValidate"
        :rules="ruleValidate"
      >
        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item
              label="Booking number"
              prop="bookingCode"
              style="margin-bottom: 24px"
            >
              <el-input v-model="formValidate.bookingCode" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              label="Last / Family name of primary guest"
              prop="lastName"
              style="margin-bottom: 0"
            >
              <el-input v-model="formValidate.lastName" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="margin-top: 24px">
          <div class="main__login__link">
            <a
              class="link-guide"
              :href="appendMarketingSiteUrl('/check-in-guide')"
              target="_blank"
              ><i class="icon icon-question-mark" />Check-in guide</a
            >
          </div>
          <el-button
            class="button--primary main__login__checkIn"
            type="primary"
            @click="handleSubmit('formValidate')"
            >Check in</el-button
          >
        </el-row>
      </el-form>
    </el-card>
  </div>
</template>

<script>
// Useful reference:
// https://vuex.vuejs.org/en/forms.html
// https://forum.vuejs.org/t/error-form-binding-with-vuex-do-not-mutate-vuex-store-state-outside-mutation-handlers/11941/8

import { mapActions } from "vuex";
import types from "../store/types";
import { UNHANDLED_ERROR_MESSAGE } from "../constants";
import { HTTPMarketing, maintenance } from "../api/http-common";

export default {
  created() {
    gtag("set", "page_path", "/login");
    gtag("event", "page_path", {
      path: "/login",
    });
  },
  async mounted() {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    if (token) {
      const result = await this.getBookingDetails(token);
      if (result) {
        const { bookingCode, lastName } = result;
        if (bookingCode && lastName) {
          this.formValidate.bookingCode = bookingCode;
          this.formValidate.lastName = lastName;
          this.handleSubmit("formValidate");
        }
      } else {
        console.log(`Unable to get booking details from token ${token}`);
      }
    }
  },
  data() {
    return {
      formValidate: {
        bookingCode: "",
        lastName: "",
      },
      ruleValidate: {
        bookingCode: [
          {
            required: true,
            message: "Please enter your booking number",
            trigger: "change keyup",
          },
        ],
        lastName: [
          {
            required: true,
            message: "Please enter your last / family name",
            trigger: "change keyup",
          },
        ],
      },
    };
  },
  methods: {
    ...mapActions([types.actions.searchBooking]),
    appendMarketingSiteUrl(path) {
      return `${process.env.MARKETING_SITE_FRONTEND_URL}${path || ""}`;
    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          const { bookingCode, lastName } = this.formValidate;
          this.searchBooking({ bookingCode, lastName })
            .then(() => {
              this.$router.push("step-1");
            })
            .catch((error) => {
              this.$message.error(error.message || UNHANDLED_ERROR_MESSAGE);
            });
        }
      });
    },
    async getBookingDetails(token) {
      try {
        const { data } = await HTTPMarketing.post(
          "/api/v0/check-in/token/exchange",
          {
            token: token,
          },
        );
        console.log("data", data);
        if (data.success) {
          return {
            bookingCode: data.data.booking_code,
            lastName: data.data.last_name,
          };
        } else {
          console.log(
            "Unable to retrieve booking details from token, error:",
            data.message,
          );
          return {
            bookingCode: "",
            lastName: "",
          };
        }
      } catch (error) {
        console.log(
          "Unable to retrieve booking details from token, error:",
          error,
        );
        this.error = error.message;
      }
    },
    isSiteOnMaintenance() {
      return maintenance;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/color";
@import "../scss/typography";

.main__login {
  padding-top: 143px;
  min-height: calc(100vh - 106px);
  height: 100%; // IE fix
  display: flex;
  justify-content: center;
  align-items: center;

  background-image: url("https://d20knvk822eu5a.cloudfront.net/s3fs-public-optimized/static-assets/online-check-in/checkin-prelogin.jpg.webp");
  //background-image: url(../assets/images/landing.jpg);
  background-size: cover;
  background-position: 50% 50%;
  z-index: -1;

  &__shade {
    position: absolute;
    top: 0;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;

    background: $black-25;
    z-index: 0;
  }

  &__title {
    margin-bottom: 8px;
    font-family: "canela-regular", serif;
    font-size: 40px;
    font-weight: 400;
    line-height: 44px;
    text-align: center;
    color: $aqua-grey-100;
  }

  &__subtitle {
    margin-bottom: 40px;
    font-family: "century-gothic", serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: center;
    color: $aqua-grey-90;
  }

  &__link {
    margin-bottom: 40px;
  }

  &__checkIn {
    width: 100%;
  }

  .el-form-item.is-required .el-form-item__label:before {
    display: none;
  }

  .link-guide {
    padding-left: 28px;
    align-self: center;

    font-family: "century-gothic", serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0.04em;
    text-align: center;

    i {
      left: 0;
    }
  }
}

.main__maintenance {
  alignment: center;
  margin-top: 24px;
  text-align: justify;
}
</style>



// WEBPACK FOOTER //
// src/components/LoginPage.vue